import React from 'react';
import { X, Trash2 } from 'lucide-react';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  policyName?: string;
  title?: string;
  message?: string;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  policyName = "此保單",
  title = "刪除保單",
  message
}) => {
  if (!isOpen) return null;

  const defaultMessage = `您確定要刪除「${policyName}」嗎？此操作無法復原。`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 mx-4 max-w-sm w-full shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)' }}>
              <Trash2 className="w-5 h-5 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold" style={{ color: 'var(--charcoal)' }}>
              {title}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" style={{ color: 'var(--medium-gray)' }} />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-sm leading-relaxed" style={{ color: 'var(--medium-gray)' }}>
            {message || defaultMessage}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 rounded-lg border text-sm font-medium transition-all duration-200"
            style={{
              background: 'var(--pure-white)',
              color: 'var(--medium-gray)',
              border: '1px solid var(--card-shadow)',
              borderRadius: '8px',
              boxShadow: '0 2px 6px var(--input-shadow)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--card-gradient)';
              e.currentTarget.style.borderColor = 'var(--brand-teal)';
              e.currentTarget.style.color = 'var(--charcoal)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--pure-white)';
              e.currentTarget.style.borderColor = 'var(--card-shadow)';
              e.currentTarget.style.color = 'var(--medium-gray)';
            }}
          >
            取消
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-12 flex items-center justify-center px-0 text-sm font-medium text-white relative overflow-hidden transition-all duration-200"
            style={{
              background: '#ef4444',
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(239, 68, 68, 0.15)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(239, 68, 68, 0.25)';
              e.currentTarget.style.background = '#dc2626';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(239, 68, 68, 0.15)';
              e.currentTarget.style.background = '#ef4444';
            }}
          >
            <div className="flex items-center justify-center gap-2">
              <Trash2 className="w-4 h-4" />
              <span className="font-medium">刪除</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
